module.exports = __webpack_public_path__ + "static/media/8775.1f3472ad.png";